module.exports = __webpack_public_path__ + "images/63cd2629d7f34b7c019afd0fe543f5e3.png";